import { yupResolver } from '@hookform/resolvers/yup';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Button, FormHelperText, Rating, Stack, TextField, Typography } from '@mui/material';
import { useController, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { ProductReviewsType } from '../../../../../../../../../../../store/api/pages-api/pages-api-types';
import { styles } from './create-review-card.styles';

type Props = {
  onChange?: (review: ProductReviewsType['reviews'][number]) => void;
  className?: string;
};

export const reviewValidation = yup.object({
  review: yup.object({
    link: yup.string().required('Required field'),
    rating: yup.string().required('Required field'),
    text: yup.string().required('Required field'),
  }),
});

const CreateReviewCard = ({ onChange }: Props) => {
  const {
    clearErrors,
    control,
    formState: { isValid },
    handleSubmit,
    setValue,
  } = useForm<ProductReviewsType['reviews'][number]>({
    resolver: yupResolver(reviewValidation),
  });

  const resetForm = () => {
    setValue('review', { link: '', rating: '', text: '' });
    if (!isValid) {
      clearErrors();
    }
  };

  const onSubmit = (data: ProductReviewsType['reviews'][number]) => {
    if (onChange) onChange(data);
    resetForm();
  };

  const ratingField = useController({ control, name: 'review.rating' });
  const textField = useController({ control, name: 'review.text' });
  const linkField = useController({ control, name: 'review.link' });

  return (
    <Stack spacing={1.5}>
      <Box>
        <Typography gutterBottom variant="subtitle2">
          Rating
        </Typography>
        <Box sx={styles.ratingRow}>
          <Rating
            onChange={(_, value) => ratingField.field.onChange(value)}
            precision={0.5}
            size="small"
            value={Number(ratingField.field.value) || 0}
          />
          <Typography color="text.secondary" variant="body2">
            {ratingField.field.value}
          </Typography>
        </Box>
        {ratingField.fieldState.error && (
          <FormHelperText error>{ratingField.fieldState.error.message}</FormHelperText>
        )}
      </Box>

      <TextField
        fullWidth
        label="Review text"
        multiline
        placeholder="Enter your text"
        size="small"
        sx={styles.textField}
        {...textField.field}
        error={textField.fieldState.invalid}
        helperText={textField.fieldState.error?.message}
      />

      <TextField
        fullWidth
        label="Review url"
        placeholder="Enter url"
        size="small"
        {...linkField.field}
        error={linkField.fieldState.invalid}
        helperText={linkField.fieldState.error?.message}
      />

      <Box sx={styles.actions}>
        <Button
          onClick={handleSubmit(onSubmit)}
          size="small"
          startIcon={<AddIcon />}
          type="button"
          variant="contained"
        >
          Add
        </Button>
        <Button
          color="inherit"
          onClick={resetForm}
          size="small"
          startIcon={<ClearIcon />}
          type="button"
          variant="outlined"
        >
          Clear
        </Button>
      </Box>
    </Stack>
  );
};

export { CreateReviewCard };
